import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "reactstrap";
import FormInput from "../../../../components/common/FormsInput/FormInput";
import "./index.scss";
import { Formik, Form } from "formik";
import { changePasswordInit, changePasswordSchema } from "./schema";
import { changePassword } from "../../../../context/actions/user";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../../context/actions/user";
import { useHistory } from "react-router-dom";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userDetail = useSelector((state) => state?.user?.user);
  const [oldPasswordType, setOldPasswordType] = useState("password");
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmNewPasswordType, setconfirmNewPasswordType] =
    useState("password");
  const [subadminDisabled, setSubadminDisabled] = useState(false);

  useEffect(() => {
    if (userDetail?.role == "superadmin" || userDetail?.role == "subadmin") {
      setSubadminDisabled(true);
    }
  }, [userDetail]);
  const submitForm = (params) => {
    dispatch(changePassword(params, (res) => {
      if(res){
        dispatch(logout(() => {
          history.push("/")
        }));
      }
    }));
  };

  /**
   * @togglePassword method call to submit valid form
   */

  const toggleOldPassword = () => {
    if (oldPasswordType === "password") {
      setOldPasswordType("text");
      return;
    }
    setOldPasswordType("password");
  };

  /**
   * @toggleconfirmPassword method call to submit valid form
   */

  const toggleNewPassword = () => {
    if (newPasswordType === "password") {
      setNewPasswordType("text");
      return;
    }
    setNewPasswordType("password");
  };

  /**
   * @toggleconfirmPassword method call to submit valid form
   */

  const toggleNewConfirmPassword = () => {
    if (confirmNewPasswordType === "password") {
      setconfirmNewPasswordType("text");
      return;
    }
    setconfirmNewPasswordType("password");
  };

  return (
    <div className="profile-form-wrapper">
      <div className="inner">
        <Formik
          initialValues={changePasswordInit}
          enableReinitialize
          validationSchema={changePasswordSchema}
          onSubmit={submitForm}
        >
          {(formik) => (
            <Form>
              <Row>
                <Col sm="12">
                  <FormInput
                    name="oldPassword"
                    onChange={formik.handleChange}
                    value={formik?.values?.oldPassword}
                    type={oldPasswordType}
                    id="oldPassword"
                    placeholder="Old Password"
                    label="Old Password"
                    isIcon
                    togglePassword={toggleOldPassword}
                    passwordType={oldPasswordType}
                  />
                </Col>
                <Col sm="12">
                  <FormInput
                    name="password"
                    value={formik?.values?.password}
                    type={newPasswordType}
                    id="newPassword"
                    placeholder="New Password"
                    label=" New Password"
                    isIcon
                    togglePassword={toggleNewPassword}
                    passwordType={newPasswordType}
                    passwordHint
                    className="account-setting-pass"
                  />
                </Col>
                <Col sm="12">
                  <FormInput
                    name="confirmPassword"
                    value={formik?.values?.confirmPassword}
                    type={confirmNewPasswordType}
                    id="confirmPassword"
                    placeholder="Confirm Password"
                    label="Confirm Password"
                    isIcon
                    togglePassword={toggleNewConfirmPassword}
                    passwordType={confirmNewPasswordType}
                  />
                </Col>
                <Col sm="12">
                  <Button
                    type="submit"
                    color="primary"
                    disabled={subadminDisabled}
                  >
                    Update
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ChangePassword;
